import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import type { BeachAmenities } from '@data-access/graphql/schema.types';
import { BeachChairAmenity, iconMapping } from './beach-chair-amenity';
type BeachChairAmenitiesListProps = {
  amenities: BeachAmenities[];
  amenitiesToShow: number;
};
export function BeachChairAmenitiesList(t0) {
  const $ = _c(7);
  const {
    amenities,
    amenitiesToShow
  } = t0;
  if (amenities.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== amenities || $[1] !== amenitiesToShow) {
    let t2;
    if ($[3] !== amenitiesToShow) {
      t2 = (amenity, index) => <li key={`${amenity}-${index}`} className={cx("flex items-center gap-4", {
        hidden: index > amenitiesToShow - 1
      })}><BeachChairAmenity Icon={iconMapping[amenity]} amenity={amenity} /></li>;
      $[3] = amenitiesToShow;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = amenities.map(t2);
    $[0] = amenities;
    $[1] = amenitiesToShow;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <ul className="grid gap-6 md:grid-cols-2 md:gap-8">{t1}</ul>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}